<template>
    <div id="patients-portal-form">
        <MdTitleRegInfo
            v-bind:RegistrationInfo="PatientTitle"
            v-bind:titlePrefix="$t('PPDbForm.Title')"
            v-bind:titleRef="'titleElementPatientSummary'"
            v-bind:patientCode="selectedPatientCode"
        >
        </MdTitleRegInfo>

        <b-row>
            <b-col sm="12" md="12">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input
                            type="text"
                            class="form-control"
                            :dir="dirInput"
                            v-model="parameters.searchCriteria"
                            @keyup.enter="searchNotes"
                        />
                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="searchNotes"
                            >
                            </MdButton>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('Shared.SearchResult')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col class="col-12 mt-2">
                <MdTable
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:VisibleEditIcon="false"
                    v-bind:FieldsDate="fieldsDateArr"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"
                >
                </MdTable>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import PatientsPortalBase from './patientsPortalBase.vue';
import Utils from '@/common/utils';

export default {
    name: 'PatientsPortalForm',
    extends: PatientsPortalBase,
    data() {
        return {
            items: [],
            totalRows: 0,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 10,
            fields: [
                {
                    key: 'description',
                    sortable: true,
                    label: this.$tc('Shared.Note', 1),
                    class: 'text-left'
                },
                {
                    key: 'assignedDate',
                    sortable: true,
                    label: this.$t('PPDbForm.AssignedDate'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'expirationDate',
                    sortable: true,
                    label: this.$t('Shared.ExpirationDate'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'isCompleted',
                    sortable: true,
                    label: this.$t('PPDbForm.IsCompleted'),
                    class: 'text-left'
                }
            ],
            fieldsDateArr: ['assignedDate', 'expirationDate'],
            showMessageIsEmpty: false,
            parameters: {
                searchCriteria: ''
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },
    methods: {
        getActiveElement() {
            return 'PPDB_PatientSetup';
        },

        onRowSelected() {},
        onFiltered() {},

        pageChanged(page) {
            this.currentPage = page;
            this.listingAsync();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.listingAsync();
        },

        searchNotes() {
            this.currentPage = 1;
            this.listingAsync();
        },

        listingAsync() {}
    },

    mounted() {
        this.listingAsync();
    }
};
</script>
